<template>
    <access-denied v-if="accessDenied" title="formas-pagamento" />
    <div id="main" v-else>
        <div class="page">
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('forma-pagamento') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs" v-if="cameFrom == 'route'">
                            <ul>
                                <li>
                                    <a class="a-inativo">
                                        {{ $t($route.meta.contexto) }}
                                    </a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'des-forma-pagamento' })">
                                        {{ $t('formas-pagamento') }}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">
                                        {{ idFrom == 0 ? $t('novo') : this.idFrom }}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$emit('voltar', true)"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                (!integracao && !isUpdate && permissao.create) ||
                                    (!integracao && isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save()"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column" :class="compact ? 'is-12' : 'is-2'">
                            <v-input
                                :id="generateId(3)"
                                ref="idErpInput"
                                v-model="formapagamento.iddes_formapagtoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                tooltipSize="is-small"
                                tooltipLabel="cod-ref"
                                :invalid="!formapagamento.iddes_formapagtoerp"
                            />
                        </div>
                        <div class="column" :class="compact ? 'is-12' : 'is-5'">
                            <v-input
                                :id="generateId(1)"
                                ref="nomeInput"
                                v-model="formapagamento.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                msg="msg-campo-obrigatorio"
                                :invalid="!formapagamento.descricao"
                                uppercase
                                tooltipLabel="informacao-descricao-forma-pagamento"
                                tooltipSize="is-small"
                                title="descricao"
                                tooltipMultilined
                                tooltipPosition="is-right"
                                required
                            />
                        </div>
                        <div class="column" :class="compact ? 'is-12' : 'is-3'">
                            <vss-select
                                :id="generateId(4)"
                                ref="debita_acertoSelect"
                                title="debita_acerto"
                                :searchable="false"
                                :options="debita_acertoSelect"
                                v-model="debita_acertoSelected"
                                mlLabels
                                tooltipLabel="debita_acerto-info"
                                tooltipSize="is-small"
                                tooltipMultilined
                                tooltipPosition="is-bottom"
                            />
                        </div>
                        <div class="column" :class="compact ? 'is-12' : 'is-2'">
                            <vss-select
                                :id="generateId(2)"
                                ref="situacaoSelect"
                                title="situacao"
                                :searchable="false"
                                :options="situacaoSelect"
                                v-model="situacaoSelected"
                                mlLabels
                                :disabled="formapagamento.id == null || cameFrom != 'route'"
                                tooltipLabel="informacao-situacao-forma-pagamento"
                                tooltipSize="is-small"
                                tooltipMultilined
                                tooltipPosition="is-top"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DespesaFormapagtoService from '@/services/despesas/DespesaFormapagtoService';
import DespesaFormapagtoValidation from '@/services/validations/vendas/DespesaFormapagtoValidation';
import Message from '@/models/Message';

export default {
    name: 'DesFormaPagamentoManage',

    props: {
        cameFrom: {
            type: String,
            default: 'route',
        },
        idFrom: {
            type: Number,
            default: 0,
        },
        compact: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('DES_FORMAPAGTO'),
            service: new DespesaFormapagtoService(this.$http, this.$router),
            validation: new DespesaFormapagtoValidation(this.msgs),
            isLoading: false,
            msgs: [],
            isSaving: false,
            formapagamento: {
                id: null,
                iddes_formapagtoerp: null,
                descricao: null,
                debita_acerto: false,
                situacao: null,
            },
            isUpdate: false,
            situacaoSelect: [{ label: 'inativo', id: 0 }, { label: 'ativo', id: 1 }],
            situacaoSelected: { label: 'ativo', id: 1 },
            debita_acertoSelect: [{ label: 'nao', id: 0 }, { label: 'sim', id: 1 }],
            debita_acertoSelected: { label: 'nao', id: 0 },
            isMobile: false,
            isLoadingEdit: false,
            accessDenied: false,
        };
    },
    created() {
        this.isChanged = false;

        if (this.idFrom != 0) this.isUpdate = true;

        this.permissao = this.hasPermissionAccess('despesas', 'cadastros', 'des-forma-pagamento');

        if (!this.isUpdate && !this.permissao.create) {
            this.accessDenied = true;
        } else if (this.idFrom != 0) {
            this.carregarDados();
        }
    },
    methods: {
        generateId(numberId) {
            return 'DesFormaPagamentoManage-' + numberId;
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;

            this.service
                .find(this.idFrom)
                .then((value) => {
                    this.formapagamento = value.content;
                    this.situacaoSelected = this.situacaoSelect[this.formapagamento.situacao];
                    this.debita_acertoSelected = this.debita_acertoSelect[
                        this.formapagamento.debita_acerto ? 1 : 0
                    ];
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                });
        },
        save() {
            this.isSaving = true;
            this.isLoading = true;
            this.isLoadingEdit = true;

            if (this.validation.validate(this.formapagamento, this.$refs)) {
                let formaPagamentoTemp = { ...this.formapagamento };
                formaPagamentoTemp = this.mapTosave(formaPagamentoTemp);
                formaPagamentoTemp.situacao = this.situacaoSelected.id;
                formaPagamentoTemp.debita_acerto = this.debita_acertoSelected.id;

                this.isSaving = true;
                this.service
                    .save(formaPagamentoTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg =
                                this.formapagamento.id != null
                                    ? 'msg-edit-forma-pagamento'
                                    : 'msg-save-forma-pagamento';

                            this.msgs.push(new Message('success', msg, true));
                            this.isChanged = false;
                            this.$emit('saved', true);
                        } else {
                            if (this.$te(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        if (e.body.message && this.$te(e.body.message)) {
                            if (e.body.message == 'msg-codigo-duplicado-n') {
                                this.msgs.push(
                                    new Message(
                                        'alert',
                                        this.$t(e.body.message, 
                                            { n: formaPagamentoTemp.iddes_formapagtoerp }
                                        ),
                                        true,
                                        false
                                    )
                                );
                            } else {
                                this.msgs.push(new Message('alert', e.body.message, true));
                            }
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                        this.isLoadingEdit = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
                this.isLoadingEdit = false;
                this.isSaving = false;
            }
        },
        mapOnSave(value) {
            return {
                id: value.id,
                descricao: value.descricao,
            };
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px 20px;
    height: auto;

    .page {
        position: relative;
    }
}
</style>
